/**
 * Pure pagination helper shared by the school-feature slices.
 *
 * The UI keeps pages 0-indexed (what MUI DataGrid emits); the backend is
 * 1-indexed. Converting here (not in the store or the HTTP layer inline) keeps
 * the mapping a single, unit-testable rule.
 */

/** Convert a 0-indexed UI page to the backend's 1-indexed page number. */
export function toServerPage(zeroBasedPage: number): number {
  return zeroBasedPage + 1;
}
